export function formatPrecioUsuario(value) {
    if (value == null) return '-';
    const num = parseFloat(value);
    return isNaN(num) ? value : num.toFixed(2);
}
